import { createFileRoute } from "@tanstack/react-router"
import EvaluationPage from "@/evaluation/layout/EvaluationPage"
import type { EvaluationTab } from "@/common"
import type { Uuid } from "@/utils"

export const Route = createFileRoute("/(user)/t/$tenantSlug/evaluations/$id")({
  component: RouteComponent,
  validateSearch: (search) =>
    search as {
      draft?: string
      revision?: string
      batchId?: Uuid
      runId?: Uuid
      nodeRunId?: Uuid
      evaluationTab?: EvaluationTab
    },
})

function RouteComponent() {
  const { evaluationTab, batchId, runId, nodeRunId } = Route.useSearch()

  return (
    <EvaluationPage
      evaluationTab={evaluationTab}
      batchId={batchId}
      runId={runId}
      nodeRunId={nodeRunId}
    />
  )
}
